// Default export to satisfy Expo Router (this file is not a route)
export default function () { return null; }

// Web-only CSS imports
import './dropdown.css';
import './prism.min.css';
import './message-content.css';
import './composer.css';

// ============================================================================
// Prevent a flash of the wrong background on page load.
//
// This runs synchronously during module evaluation — BEFORE React mounts
// anything — so there is no gap where the wrong body color is visible. The
// theme it resolves to is shared with the inline <head> script in +html.jsx so
// both land on the color ThemeContext will settle on. See lib/bootTheme.js.
// ============================================================================
import { THEME_BACKGROUNDS, resolveBootTheme } from '@/lib/bootTheme';

try {
  const bg = THEME_BACKGROUNDS[resolveBootTheme()] || THEME_BACKGROUNDS.white;
  document.documentElement.style.backgroundColor = bg;
  document.body.style.backgroundColor = bg;
} catch (_) {
  // Nothing to do — the <head> script already painted <html>, and the app
  // repaints as soon as ThemeContext mounts.
}
